import React, { useRef } from 'react';

import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Title,
  Group,
  Button,
  Modal
} from '@mantine/core';

import IntegrationForm from '../components/integration/IntegrationForm';
import IntegrationList from '../components/integration/IntegrationList';

const ManageIntegrations: React.FC = () => {
  const [addModalOpen, setAddModalOpen] = React.useState(false);
  const integrationListRefetchRef = useRef<(() => void) | null>(null);

  const handleAddSuccess = () => {
    setAddModalOpen(false);
    if (integrationListRefetchRef.current) {
      integrationListRefetchRef.current();
    }
  };

  return (
    <>
      <Group justify="space-between" mb="xl">
        <Title order={1}>Manage Integrations</Title>
        <Button
          leftSection={<FontAwesomeIcon icon={faPlus} />}
          variant="filled"
          onClick={() => setAddModalOpen(true)}
        >
          Add Integration
        </Button>
      </Group>

      <IntegrationList
        onRefetchReady={(refetch: () => void) => {
          integrationListRefetchRef.current = refetch;
        }}
      />

      <Modal
        opened={addModalOpen}
        size="lg"
        title="Add Integration"
        onClose={() => setAddModalOpen(false)}
      >
        <IntegrationForm
          onCancel={() => setAddModalOpen(false)}
          onSuccess={handleAddSuccess}
        />
      </Modal>
    </>
  );
};

export default ManageIntegrations;

